import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';
import { DomHelper } from '../helpers/dom.helper';

export class KeyboardServiceAndroid {
    public static async start() {
        this.addClassToDOM();

        await Keyboard.addListener('keyboardWillShow', (e: KeyboardInfo) => {
            this.hideFooter();
        });

        await Keyboard.addListener('keyboardDidShow', (e: KeyboardInfo) => {
            // Faire défiler manuellement vers l'élément actif
            setTimeout(async () => {
                const activeElement = document.activeElement;
                if (activeElement && activeElement instanceof HTMLElement) {
                    // Trouver le ion-content parent
                    const ionContent = activeElement.closest('ion-content');
                    if (!ionContent) return;

                    // Attendre que le ion-content soit prêt
                    await ionContent.componentOnReady?.();

                    const scrollElement = await (ionContent as any).getScrollElement();
                    if (!scrollElement) return;

                    // Calculer la position absolue de l'élément dans le scrollElement
                    const scrollElementRect = scrollElement.getBoundingClientRect();
                    const elementRect = activeElement.getBoundingClientRect();

                    const keyboardHeight = e.keyboardHeight;
                    const viewportHeight = window.innerHeight;
                    const availableHeight = viewportHeight - keyboardHeight;

                    // Position actuelle du scroll
                    const currentScrollTop = scrollElement.scrollTop;

                    // Position absolue de l'élément dans le document scrollable
                    const elementAbsoluteTop =
                        elementRect.top - scrollElementRect.top + currentScrollTop;

                    // Position relative au viewport
                    const elementViewportTop = elementRect.top;
                    const elementViewportBottom = elementRect.bottom;

                    // Vérifier si l'élément est caché par le clavier ou hors de vue
                    if (elementViewportBottom > availableHeight || elementViewportTop < 0) {
                        // Calculer la position pour centrer l'élément dans l'espace visible
                        const targetScrollTop =
                            elementAbsoluteTop + availableHeight / 2 + elementRect.height / 2;
                        scrollElement.scrollTop = Math.max(0, targetScrollTop);
                    }
                }
            }, 100);
        });

        await Keyboard.addListener('keyboardWillHide', () => {
            this.showFooter();
        });
    }

    public static async stop() {
        await Keyboard.removeAllListeners();
    }

    private static addClassToDOM() {
        let css = `ion-footer {
                            opacity: revert;
                            max-height: revert;
                            visibility: visible;
                        }

                        ion-footer.hidden {
                            opacity: 0;
                            max-height: 0;
                            visibility: hidden;
                        }`;

        DomHelper.addOrReplaceCustomCSS(css);
    }

    private static hideFooter() {
        const footers = document.querySelectorAll('ion-footer');
        if (footers.length > 0) {
            const lastFooter = footers[footers.length - 1];
            lastFooter.classList.add('hidden');
        }
    }

    private static showFooter() {
        const footers = document.querySelectorAll('ion-footer');
        if (footers.length > 0) {
            const lastFooter = footers[footers.length - 1];
            lastFooter.classList.remove('hidden');
        }
    }
}
